/**
 * @module SharedConstants
 * @package @geenius/i18n
 * @description Centralizes shared i18n constants used by every Geenius i18n
 * variant. Keeping locale defaults and loader defaults here prevents contract
 * drift between the shared runtime, framework bindings, and Convex helpers.
 */

import type { Locale } from "./types";

/** Default locale used when no locale is specified. */
export const DEFAULT_LOCALE: Locale = "en";

/** LocalStorage key used to persist the user's chosen locale. */
export const DEFAULT_LOCALE_STORAGE_KEY = "geenius-i18n-locale";

/** All supported locale codes (derived from LOCALE_INFO keys). */
export const SUPPORTED_LOCALES: readonly Locale[] = [
  "en",
  "fr",
  "de",
  "es",
  "pt",
  "it",
  "nl",
  "ru",
  "zh-Hans",
  "zh-Hant",
  "ja",
  "ko",
  "ar",
  "he",
  "tr",
  "pl",
  "sv",
  "da",
  "fi",
  "nb",
  "hi",
  "id",
  "vi",
  "fa",
  "uk",
  "cs",
  "hu",
  "ro",
  "el",
  "th",
  "bn",
  "ur",
  "ms",
  "fil",
];

/** Locales that use right-to-left text direction. */
export const RTL_LOCALE_CODES: readonly Locale[] = ["ar", "he", "fa", "ur"];

/** Default translation namespace. */
export const DEFAULT_NAMESPACE = "translations";

/** Default base URL for fetching translation JSON files. */
export const DEFAULT_TRANSLATIONS_BASE_URL = "/locales";

/** Default translation cache duration in milliseconds (1 hour). */
export const DEFAULT_CACHE_DURATION_MS = 3_600_000;
